import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import HotelDetail from "../../hotels/types/HotelDetail";

type Output = HotelDetail;

export default function useEventCityHotelsDetailsGet(
    eventCityId: any,
    hotelId: any,
options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["event-city-hotel", eventCityId, hotelId],
        () => {
            return client.get<any>(`city_events/${eventCityId}/hotel_events/${hotelId}`);
        },
        options
    );
}